export default __webpack_public_path__ + "66866a9ed7e6e4a32dc81f8e2aff75e3.svg";